import AutocompleteDropdown from 'componentes/generic/AutoComplete.js';
import WizardInput from 'componentes/wizard/WizardInput.js';
import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
const URIConfig = ApiEndpoint + 'configuration/';
import PropTypes from 'prop-types';
import MyModal from 'helpers/MyModal.js';
import EditTipoProductoQueja from 'pages/Configuration/_EditTipoProductoQueja.js';
import EditTipoPlataforma from 'pages/Configuration/_EditTipoPlataforma.js';
import IconButton from 'componentes/common/IconButton.js';
import { useQuejaWizardContext } from 'context/QuejaWizardProvider';

const ProductoData = ({ register, errors, setValue }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [tiposProducto, setTiposProducto] = useState(null);
  const [openModalTipoProducto, setOpenModalTipoProducto] = useState(false);
  const [openTipoPlataforma, setOpenTipoPlataforma] = useState(false);
  const [tiposPlataforma, setTiposPlataforma] = useState(null);
  const [statusFacturacion, setStatusFacturacion] = useState(null);
  const {
    selectedTipoProductoDescription,
    setSelectedTipoProductoDescription
  } = useQuejaWizardContext();
  const handleCloseTipoProducto = () => {
    setOpenModalTipoProducto(false);
    getTiposProducto();
  };
  const handleCloseTipoPlataforma = () => {
    setOpenTipoPlataforma(false);
    getTiposPlataforma();
  };
  const getTiposProducto = async () => {
    setTiposProducto(null);

    httpClient('GET', URIConfig + 'tiposproducto/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var deleg = response.data.map(item => {
            return { id: item.idtipoproducto, description: item.descripcion };
          });
          setTiposProducto(deleg);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  const getTiposPlataforma = async () => {
    setTiposPlataforma(null);

    httpClient('GET', URIConfig + 'tiposplataforma/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var deleg = response.data.map(item => {
            return { value: item.idplataforma, label: item.plataforma };
          });
          setTiposPlataforma(deleg);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  const getStatusFacturacion = async () => {
    setStatusFacturacion(null);

    httpClient('GET', URIConfig + 'statusbytype/' + 7, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var customersList = response.data.map(item => {
            return { value: item.idstatus, label: item.descripcion };
          });
          setStatusFacturacion(customersList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!tiposProducto) getTiposProducto();
    if (!statusFacturacion) getStatusFacturacion();
    if (!tiposPlataforma) getTiposPlataforma();
  }, []);
  return (
    <>
      <Row className="g-2 mb-3">
        <Col>
          <WizardInput
            label="Numero de Pedido"
            name="numeropedido"
            errors={errors}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('numeropedido', { required: true })
            }}
          />
        </Col>
        <Col></Col>
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          {/* <Link className="py-1 fs-10 font-sans-serif" onClick={() => setOpenTipoPlataforma(true)} to="#!">
            Agregar
          </Link> */}
          <IconButton
            variant="falcon-default"
            size="sm"
            icon="plus"
            style={{ float: 'right', marginRight: '5px', fontSize: 'smallest' }}
            transform="shrink-3"
            onClick={() => setOpenTipoPlataforma(true)}
          >
            Agregar
          </IconButton>
          {tiposPlataforma && (
            <WizardInput
              label="Tipo de Plataforma"
              name="tipoPlataforma"
              type="select"
              errors={errors}
              options={tiposPlataforma}
              formGroupProps={{ className: 'mb-3' }}
              formControlProps={{
                ...register('tipoPlataforma', { required: true })
              }}
            />
          )}
        </Col>
        <Col>
          <WizardInput
            label="Nombre del Seller"
            name="seller"
            errors={errors}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('seller', { required: true })
            }}
          />
        </Col>
      </Row>
      <Row className="g-2 mb-3">
        <Col>
          {tiposProducto && (
            <>
              <AutocompleteDropdown
                items={tiposProducto}
                placeholder="Selecciona un tipo de Producto"
                currentSelected={selectedTipoProductoDescription}
                register={register}
                name="tipoproducto"
                setValue={setValue}
                errors={errors}
                addButton={true}
                addFunction={() => setOpenModalTipoProducto(true)}
                setCurrentSelected={value => {
                  setSelectedTipoProductoDescription(value.description);
                  // setIdSubCustomer(value.id);
                }}
                // setSelected={value => {
                //   setSelectedTipoProductoDescription(value);
                //   setValue('tipoproducto', value, {
                //     shouldValidate: true
                //   });
                // }}
              />
            </>
          )}
        </Col>
        <Col>
          {statusFacturacion && (
            <WizardInput
              label="Status Facturacion"
              name="statusFacturacion"
              type="select"
              errors={errors}
              options={statusFacturacion}
              formGroupProps={{ className: 'mb-3' }}
              formControlProps={{
                ...register('statusFacturacion', { required: true })
              }}
            />
          )}
        </Col>
      </Row>{' '}
      <Row className="g-2 mb-3">
        <Col>
          {' '}
          <WizardInput
            label="Monto Pagado"
            name="montopagado"
            errors={errors}
            type="number"
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('montopagado', { required: true })
            }}
          />
        </Col>
        <Col>
          <WizardInput
            label="Monto Real"
            name="montoreal"
            type="number"
            errors={errors}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('montoreal', { required: true })
            }}
          />
        </Col>
      </Row>
      {openModalTipoProducto && (
        <MyModal
          id="id_myModal"
          title={'Agregar Tipo de Producto'}
          openModal={openModalTipoProducto}
          closeModal={handleCloseTipoProducto}
        >
          <EditTipoProductoQueja
            idTipoProducto={0}
            closeModal={handleCloseTipoProducto}
          />
        </MyModal>
      )}
      {openTipoPlataforma && (
        <MyModal
          id="id_myModal"
          title={'Agregar Tipo de Plataforma'}
          openModal={openTipoPlataforma}
          closeModal={handleCloseTipoPlataforma}
        >
          <EditTipoPlataforma
            idTipoProducto={0}
            closeModal={handleCloseTipoPlataforma}
          />
        </MyModal>
      )}
    </>
  );
};
ProductoData.propTypes = {
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func,
  errors: PropTypes.object,
  watch: PropTypes.func
};
export default ProductoData;
